module.exports = __webpack_public_path__ + "img/73.1ef7d34a.png";